import { Detail } from "./components";
import "react-toastify/dist/ReactToastify.css";

function App() {
  return <Detail />;
}

export default App;
